import type { RouteRecordRaw } from 'vue-router';

// A4 run-live routes per ADR-007: live dashboard = admin|staff.
export const routes: RouteRecordRaw[] = [
  {
    path: '/auctions/:id/run-live',
    name: 'run-live',
    component: () => import('./pages/LiveDashboardPage.vue'),
    meta: {
      requiresAdminAuth: true,
      requiredRole: 'any',
      // Pre-live statuses render the Console's introduction state (2026-07-31
      // design decision: the first encounter with the day-of surface should
      // not be during the live event).
      lifecycle: ['draft', 'published', 'open'],
    },
  },
];
